import { render } from "./footer-help.vue?vue&type=template&id=5f52ee16&scoped=true"
import script from "./footer-help.vue?vue&type=script&lang=js"
export * from "./footer-help.vue?vue&type=script&lang=js"

import "./footer-help.vue?vue&type=style&index=0&id=5f52ee16&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f52ee16"]])

export default __exports__